<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      ref="tabla"
      :titulo="$t ('Aparatos')"
      icono="mdi-boom-gate"
      tabla="apa"
      :campos="['id_apa-', 'id_ins', 'id_tipapa', 'num', 'des+', 'id_modapa', '__liszonori', '__liszondes']"
      :campos-filtrables="['id_ins']"
      :objeto-definicion-campos="dc"
      :objeto-registro-formulario="rf"
      busqueda-rapida
      :titulo-crud="$t ('aparato')"
      :permitir-anadir="permisoEscritura"
      :permitir-modificar="permisoEscritura"
      :permitir-eliminar="permisoEscritura"
      @campo-formulario-datos-montado="campoFormularioDatosMontado"
    />

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";

export default {
  components: { TablaDatosAPI },
  data() {
    return {
      dc: {},
      rf: {}
    }
  },
  computed: {
    permisoEscritura() {
      return this.$store.operador.atributosRol.includes ("modconapa");
    }
  },
  methods: {
    onFocusCampoDescripcion(){
      if (!this.rf['des'] && this.rf['id_tipapa'] && this.rf['num'])
        this.$set (this.rf, 'des', this.dc ['id_tipapa'].dominio_valores [this.rf['id_tipapa']] + ' ' + this.rf['num']);
    },
    campoFormularioDatosMontado(campo) {
      if (campo.nombreCampo == 'des') {
        campo.$children[0].onFocus = this.onFocusCampoDescripcion;
      }
    }
  }
};
</script>

<style>
</style>